"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFetchTemplate = void 0;
const react_1 = require("react");
const useFetchTemplate = (selectedTemplateKey, chat) => {
    (0, react_1.useEffect)(() => {
        function getTemplate(templateKey) {
            return __awaiter(this, void 0, void 0, function* () {
                if (chat && templateKey) {
                    yield chat.fetchTemplate(templateKey);
                }
            });
        }
        (() => __awaiter(void 0, void 0, void 0, function* () {
            if (selectedTemplateKey) {
                yield getTemplate(selectedTemplateKey);
            }
        }))();
    }, [selectedTemplateKey, chat]);
    const handleSubmit = (data, selectedTemplateInfo, selectedRole, response, onTimeout) => {
        if (selectedTemplateInfo.form &&
            selectedTemplateInfo.form.formToPayloadDataHandler) {
            const formMappedData = selectedTemplateInfo.form.formToPayloadDataHandler(data, selectedTemplateInfo.form, selectedRole);
            const formPayload = Object.assign(Object.assign({}, formMappedData), { form: Object.assign(Object.assign(Object.assign({}, (selectedRole && { filledAs: selectedRole })), { templateType: selectedTemplateKey }), formMappedData.form) });
            if (chat)
                chat.sendFormMessage(formPayload, response, onTimeout);
        }
    };
    return {
        handleSubmit,
    };
};
exports.useFetchTemplate = useFetchTemplate;
